module.exports = __webpack_public_path__ + "media/images/arrow-right-2b4f028f.png";